// calendar-api is its own standalone service, not behind the coremind-api gateway. Real bug hit
// live 2026-09-10: a hardcoded `.env.development` localhost URL resolves to the VIEWER's own
// machine, not the dev box -- only ever worked testing from the same box calendar-api runs on.
// Derive it at runtime instead: when served through ui.<env>.offsetmind.com, calendar-api is
// real-routed at `/calendar-api` on that same host (a Traefik IngressRoute + isolated Service,
// same shape as the calendar site's own routing); only fall back to the static env value for
// genuinely local access.
export function resolveCalendarApiUrl() {
    const env = window.__COREMIND_ENV__ ?? {};
    if (window.location.hostname.startsWith("ui.")) {
        return `${window.location.origin}/calendar-api`;
    }
    return env.VITE_CALENDAR_API_URL ?? "";
}
